<template>
<!-- contents -->
<div id="contents">
    <div class="contents_wrap">
        <!-- contents_head -->
        <!-- breadcrumbs -->
        <skp-breadcrumbs @page-title="val => pageTitle = val" />
        <!-- //breadcrumbs -->
        <h2 class="pg_title">{{ pageTitle }}</h2>
        <!-- //contents_head -->

        <!--Basic Info-->
        <div class="sub_tit mt10">{{ $t('SUBTITLE.GLOBAL.BASIC.INFO') }}</div>
        <!-- //Basic Info head -->
        <!-- detail_Basic Info -->
        <table class="create_table" v-if="getIsDetail">
            <colgroup>
                <col width="13.5%" />
                <col width="*" />
                <col width="13.5%" />
                <col width="*" />
            </colgroup>
            <tbody>
                <tr>
                    <th>{{ $t('FIELD.GLOBAL.SUBSIDIARY') }}<em class="txt_mandatory">*</em></th>
                    <td colspan="3" data-input-type="select">
                        <fieldset class="ui_fieldset set_2 input-58">
                            <div>
                                <select id="RHQ_CD" name="RHQ_CD"
                                        class="slt_white w100"
                                        v-model="RHQ_CD"
                                        @change="changeRhqCd($event)"
                                        v-validation="{ groupId: 'basic' }">
                                    <option value="" disabled selected>{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
                                    <option v-for="(item, index) in rhqCdList" :key="item.code" :value="item.code">{{item.codeName}}</option>
                                </select>
                            </div>
                            <div>
                                <select id="CORP_NO" name="CORP_NO" class="slt_white w100"
                                        v-model="CORP_NO" 
                                        @change="changeCorpCd($event)"
                                        v-validation="{ groupId: 'basic' }">
                                    <option value="" disabled selected>{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
                                    <option v-for="(item, index) in corpCdList" :key="item.code" :value="item.code" >{{item.codeName}}</option>
                                </select>
                            </div>
                        </fieldset>
                    </td>
                </tr>
                <tr>
                    <th>{{ $t('FIELD.GLOBAL.CATEGORY') }}</th>
                    <td>
                        <fieldset class="ui_fieldset set_2">
                            <div>
                                <select
                                    id="BOARD_TYPE1"
                                    name="BOARD_TYPE1"
                                    v-model="BOARD_TYPE1"
                                    class="slt_white w100"
                                    @change="changeBoardType1($event)"
                                >
                                    <option value="" disabled selected>{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
                                    <option v-show="boardType1List.length > 0"
                                            v-for="item in boardType1List"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                            <div>
                                <select
                                    id="BOARD_TYPE2"
                                    name="BOARD_TYPE2"
                                    v-model="BOARD_TYPE2"
                                    class="slt_white w100"
                                >
                                    <option value="" disabled selected>{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
                                    <option v-show="boardType2List.length > 0"
                                            v-for="item in boardType2List"
                                            :key="item.code"
                                            :value="item.code"
                                            :data-menu-grp-dtl-cd="item.menuGrpDtlCd"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                        </fieldset>
                    </td>
                    <th>{{ $t('FIELD.ADMIN.MENU.ORDER') }}</th>
                    <td>
                        <fieldset class="ui_fieldset set_2">
                            <div>
                                <select
                                    id="NEXT_ORDER1"
                                    name="NEXT_ORDER1"
                                    v-model="NEXT_ORDER1"
                                    class="slt_white w100"
                                    @change="changeOrder($event)"
                                >
                                    <option value="" disabled selected>{{ $t('FIELD.NEXT.OF') }}</option>
                                    <option v-show="nextOrder1List.length > 0"
                                            v-for="item in nextOrder1List"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                            <div>
                                <select
                                    id="NEXT_ORDER2"
                                    name="NEXT_ORDER2"
                                    v-model="NEXT_ORDER2"
                                    class="slt_white w100"
                                >
                                    <option value="" disabled selected>{{ $t('FIELD.NEXT.OF') }}</option>
                                    <option v-show="nextOrder2List.length > 0"
                                            v-for="item in nextOrder2List"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                        </fieldset>
                    </td>
                </tr>
                <tr>
                    <th>{{ $t('FIELD.ADMIN.BOARD.NAME.E') }}<em class="txt_mandatory">*</em></th>
                    <td>
                        <input  type="text" class="text_input w100"
                                :placeholder="$t('FIELD.ADMIN.BOARD.NAME.E')"
                                v-model="BOARD_NM_EN"
                                v-validation="{ groupId: 'basic' }" />
                    </td>
                    <th>{{ $t('FIELD.ADMIN.BOARD.NAME.LOCAL') }}<em class="txt_mandatory">*</em></th>
                    <td>
                        <input  type="text" class="text_input w100"
                                :placeholder="$t('FIELD.ADMIN.BOARD.NAME.LOCAL')"
                                v-model="BOARD_NM"
                                v-validation="{ groupId: 'basic' }" />
                    </td>
                </tr>
                <tr>
                    <th>{{ $t('FIELD.ADMIN.BOARD.DESCRIPTION.E') }}</th>
                    <td colspan="3">
                        <textarea
                            class="text_textarea w100"
                            :placeholder="$t('FIELD.ADMIN.BOARD.DESCRIPTION.E')"
                            v-model="BOARD_DESC_EN"
                        ></textarea>
                    </td>
                </tr>
                <tr>
                    <th>{{ $t('FIELD.ADMIN.BOARD.DESCRIPTION.LOCAL') }}</th>
                    <td colspan="3">
                        <textarea
                            class="text_textarea w100"
                            :placeholder="$t('FIELD.ADMIN.BOARD.DESCRIPTION.LOCAL')"
                            v-model="BOARD_DESC"
                        ></textarea>
                    </td>
                </tr>
                <!--
                <tr>
                    <th>{{ $t('FIELD.ADMIN.USE.SKIN.GSPN') }}</th>
                    <td>
                        <select class="slt_white w100">
                            <option>test1</option>
                        </select>
                    </td>
                    <th>{{ $t('FIELD.ADMIN.USE.SKIN.SCMS') }}</th>
                    <td>
                        <select class="slt_white w100">
                            <option>test1</option>
                        </select>
                    </td>
                </tr>
                -->
                <tr>
                    <th>{{ $t('FIELD.ADMIN.DISCAEDED.PERIOD') }}</th>
                    <td colspan="3">
                        <select class="slt_white input-58" v-model.number="DISCARDED_PERIOD">
                            <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                            <option v-show="discardedPreiodList.length > 0"
                                    v-for="item in discardedPreiodList"
                                    :key="item.code"
                                    :value="item.code"
                                    >{{item.codeName}}</option>
                        </select>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="btn_wrap_full topLine"></div>
        <!-- //detail_Basic Info -->

        <!--List Info-->
        <div class="sub_tit mt25">{{ $t('SUBTITLE.GLOBAL.LIST.INFO') }}</div>
        <!-- //List Info head -->
        <!-- detail_List Info -->
        <table class="create_table" v-if="getIsDetail">
            <colgroup>
                <col width="13.5%" />
                <col width="*" />
                <col width="13.5%" />
                <col width="*" />
            </colgroup>
            <tbody>
                <tr>
                    <th>{{ $t('FIELD.ADMIN.MAX.OF.COUNT') }}</th>
                    <td data-input-type="input">
                        <input type="number" class="text_input w100" :placeholder="$t('FIELD.ADMIN.MAX.OF.COUNT')" v-model.number="LIST_CNT" />
                    </td>
                    <td colspan="2"></td>
                    <!--
                    <th>{{ $t('FIELD.ADMIN.NEW.IMAGE') }}</th>
                    <td data-input-type="input">
                        <fieldset class="ui_fieldset">
                            <label class="checkbox-wrap mr10">
                                <input type="checkbox" name="" value="" />
                                <i class="check-icon"></i>
                                <em>{{ $t('FIELD.GLOBAL.USE') }}</em>
                            </label>
                            <label class="input-wrap">
                                <input type="text" class="text_input" placeholder="Days" value="" />
                            </label>
                        </fieldset>
                    </td>
                    -->
                </tr>
                <!--
                <tr>
                    <th>{{ $t('FIELD.ADMIN.DETAIL.QUICK.VIEW') }}</th>
                    <td>
                        <label class="checkbox-wrap">
                            <input type="checkbox" name="" value="" checked="" />
                            <i class="check-icon"></i>
                            <em>{{ $t('FIELD.GLOBAL.USE') }}</em>
                        </label>
                    </td>
                    <th>{{ $t('FIELD.ADMIN.THUMBNAIL.IMAGE') }}</th>
                    <td>
                        <label class="checkbox-wrap">
                            <input type="checkbox" name="" value="" checked="" />
                            <i class="check-icon"></i>
                            <em>{{ $t('FIELD.GLOBAL.USE') }}</em>
                        </label>
                    </td>
                </tr>
                -->
            </tbody>
        </table>
        <div class="btn_wrap_full topLine"></div>
        <!-- //List Info Info -->

        <!--Detail Info-->
        <div class="sub_tit mt25">{{ $t('SUBTITLE.GLOBAL.DETAIL.INFO') }}</div>
        <!-- //Detail Info head -->
        <!-- detail_Detail Info -->
        <table class="create_table" v-if="getIsDetail">
            <colgroup>
                <col width="13.5%" />
                <col width="*" />
                <col width="13.5%" />
                <col width="*" />
            </colgroup>
            <tbody>
                <!--
                <tr>
                    <th>{{ $t('FIELD.ADMIN.FILE.ATTACH') }}</th>
                    <td>
                        <label class="checkbox-wrap">
                            <input type="checkbox" name="" value="" checked="" />
                            <i class="check-icon"></i>
                            <em>{{ $t('FIELD.GLOBAL.USE') }}</em>
                        </label>
                    </td>
                    <th>{{ $t('FIELD.ADMIN.EVALUTION') }}</th>
                    <td>
                        <label class="checkbox-wrap">
                            <input type="checkbox" name="" value="" checked="" />
                            <i class="check-icon"></i>
                            <em>{{ $t('FIELD.GLOBAL.USE') }}</em>
                        </label>
                    </td>
                </tr>
                -->
                <tr>
                    <!--
                    <th>{{ $t('FIELD.GLOBAL.RECOMMEND') }}</th>
                    <td data-input-type="checkbox">
                        <label class="checkbox-wrap mr10">
                            <input type="checkbox" name="" value="" checked="" />
                            <i class="check-icon"></i>
                            <em>{{ $t('FIELD.GLOBAL.USE') }}</em>
                        </label>
                    </td>
                    -->
                    <th>{{ $t('FIELD.ADMIN.VERIFY') }}</th>
                    <td data-input-type="checkbox" colspan="3">
                        <label class="checkbox-wrap mr10">
                            <input type="checkbox" v-model="VERIFY_USE_YN"/>
                            <i class="check-icon"></i>
                            <em>{{ $t('FIELD.GLOBAL.USE') }}</em>
                        </label>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="btn_wrap_full topLine"></div>
        <!-- //Detail Info -->

        <!--Register Info-->
        <div class="sub_tit mt25">{{ $t('SUBTITLE.GLOBAL.REGISTER.INFO') }}</div>
        <!-- //Register Info head -->
        <!-- detail_Register Info -->
        <table class="create_table" v-if="getIsDetail">
            <colgroup>
                <col width="13.5%" />
                <col width="*" />
                <col width="13.5%" />
                <col width="*" />
            </colgroup>
            <tbody>
                <tr v-if="typeof(detail.REG_USER_NM) !== 'undefined'">
                    <th>{{ $t('FIELD.GLOBAL.REGISTERED.BY') }}</th>
                    <td data-input-type="text">{{ detail.REG_USER_NM }}</td>
                    <th>{{ $t('FIELD.GLOBAL.REGISTERED.DATE') }}</th>
                    <td data-input-type="text">{{ detail.REG_DT }}</td>
                </tr>
                <tr v-if="typeof(detail.MODF_USER_NM) !== 'undefined'">
                    <th>{{ $t('FIELD.GLOBAL.UPDATED.BY') }}</th>
                    <td data-input-type="text">{{ detail.MODF_USER_NM }}</td>
                    <th>{{ $t('FIELD.GLOBAL.UPDATED.DATE') }}</th>
                    <td data-input-type="text">{{ detail.MODF_DT }}</td>
                </tr>
            </tbody>
        </table>
        <div class="btn_wrap_full topLine"></div>
        <!-- //Register Info-->
        <!---->
        <div class="sub_head_Warp">
            <div class="sub_tit mt25">{{ $t('SUBTITLE.GLOBAL.LIST.COLUMN') }}</div>
            <div class="btn_wrap" v-if="this.sysAdmYn == 'Y'">
                <a href="javascript:" class="btn_white btnUp" title="" @click="btnColUp"></a>
                <a href="javascript:" class="btn_white btnDown" title="" @click="btnColDown"></a>
                <a href="javascript:" class="btn_white" title="" @click="btnColAdd">{{ $t('BUTTON.GLOBAL.ADD') }}</a>
                <a href="javascript:" class="btn_white" title="" @click="btnColDelete">{{ $t('BUTTON.GLOBAL.DELETE') }}</a>
            </div>
        </div>
        <table class="scroll_table">
            <colgroup>
                <col width="5%" />
                <col width="25%" />
                <col width="*" />
                <col width="20%" />
                <col width="20%" />
            </colgroup>
            <thead>
                <tr>
                    <th class="w10">
                        <label class="checkbox-wrap">
                            <input type="checkbox" @click="chkAllHeaderList($event)"/><i class="check-icon"></i>
                        </label>
                    </th>
                    <th>{{ $t('FIELD.GLOBAL.COLUMN') }}</th>
                    <th>{{ $t('FIELD.ADMIN.HEADER.NAME') }}</th>
                    <th>{{ $t('FIELD.GLOBAL.WIDTH') }} (%)</th>
                    <th>{{ $t('FIELD.GLOBAL.ALIGN') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="headerList.length === 0 || tableHeaderList.length === 0">
                    <td class="tC" colspan="5">
                        {{ $t('FIELD.GLOBAL.NODATA') }}
                    </td>
                </tr>
                <tr v-else v-for="(header, idx) in headerList">
                    <td class="tC w10">
                        <label class="checkbox-wrap" :for="header.BOARD_HEADER_ID">
                            <input  type="checkbox"
                                    :id="header.BOARD_HEADER_ID"
                                    :name="header.BOARD_HEADER_ID"
                                    :value="header.BOARD_HEADER_ID"
                                    v-model="selHeaderList"
                            /><i class="check-icon"></i>
                        </label>
                    </td>
                    <td class="tC">
                        <select class="slt_white w100" v-model="header.HEADER_COLUMN">
                            <option value="" disabled selected>{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
                            <option v-show="tableHeaderList.length > 0"
                                    v-for="item in tableHeaderList"
                                    :value="item.code"
                            >{{item.codeName}}</option>
                        </select>
                    </td>
                    <td class="tC">
                        <span class="clearable">
                            <input type="text" class="text_input w100" :placeholder="$t('FIELD.ADMIN.HEADER.NAME')" v-model="header.HEADER_NAME" />
                        </span>
                    </td>
                    <td class="tC">
                        <span class="clearable">
                            <input type="text" class="text_input w100" :placeholder="$t('FIELD.GLOBAL.WIDTH')" v-model="header.HEADER_WIDTH" />
                        </span>
                    </td>
                    <td class="tC">
                        <select class="slt_white w100" v-model="header.HEADER_ALIGN">
                            <option value="" disabled selected>{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
                            <option value="L">Left</option>
                            <option value="C">Center</option>
                            <option value="R">Right</option>
                        </select>
                    </td>
                </tr>
            </tbody>
        </table>
        <!---->

        <!-- Authorization tit -->
        <div class="sub_tit mt25 w100">{{ $t('SUBTITLE.GLOBAL.AUTHORIZATION') }}</div>
        <!-- //Authorization tit -->

        <!-- //Authorization tab -->
        <div class="tab_wrap">
            <ul class="tab_menu_02 tab_menus">
                <li class="on"><a href="javascript:" @click="setTabName($event)" data-id="role">{{ $t('FIELD.USER.ROLE') }}</a></li>
                <!--
                    <li class=""><a href="javascript:" @click="setTabName($event)" data-id="team">{{ $t('FIELD.USER.TEAM') }}</a></li>
                -->
                <li class=""><a href="javascript:" @click="setTabName($event)" data-id="user">{{ $t('FIELD.GLOBAL.USER') }}</a></li>
                <!-- <li class=""><a href="javascript:">Team</a></li>  보이진 않고 사용함 -->
                <div class="btn_wrap fR" v-if="this.sysAdmYn == 'Y'">
                    <a href="javascript:" class="btn_sm_white" @click="btnAuthAdd">{{ $t('BUTTON.GLOBAL.ADD') }}</a>
                    <a href="javascript:" class="btn_sm_white" @click="btnAuthDelete">{{ $t('BUTTON.GLOBAL.DELETE') }}</a>
                </div>
            </ul>
            <div class="tab_contents_list">
                <div class="tab_cont">
                    <table class="scroll_table">
                        <colgroup>
                            <col width="15%" />
                            <col width="30%" class="pc_only" />
                            <col width="30%" class="pc_only" />
                            <col width="*" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th class="w10">
                                    <label class="checkbox-wrap">
                                        <input type="checkbox" @click="chkAllAuthList" />
                                        <i class="check-icon"></i>
                                    </label>
                                </th>
                                <th>{{ $t('FIELD.GLOBAL.ID') }}</th>
                                <th>{{ $t('FIELD.GLOBAL.ROLE.NAME') }}</th>
                                <th>{{ $t('FIELD.GLOBAL.CREATION') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="resultAuth.length === 0">
                                <td class="tC">
                                    {{ $t('FIELD.GLOBAL.NODATA') }}
                                </td>
                            </tr>
                            <tr v-else v-for="(auth, idx) in resultAuth">
                                <td class="tC w10">
                                    <label class="checkbox-wrap">
                                        <input type="checkbox" :value="auth.AUTHCORPID" v-model="selResultAuth" />
                                        <i class="check-icon"></i>
                                    </label>
                                </td>
                                <td class="tC">{{ auth.AUTHID }}</td>
                                <td class="tC">{{ auth.AUTHNM }}</td>
                                <td class="tC">{{ auth.CREATIONYN }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!--
                <div class="tab_cont" style="display: none;">
                    <table class="scroll_table">
                        <colgroup>
                            <col width="15%" />
                            <col width="30%" class="pc_only" />
                            <col width="30%" class="pc_only" />
                            <col width="*" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th class="w10">
                                    <label class="checkbox-wrap">
                                        <input type="checkbox" @click="chkAllAuthList" />
                                        <i class="check-icon"></i>
                                    </label>
                                </th>
                                <th>{{ $t('FIELD.GLOBAL.ID') }}</th>
                                <th>{{ $t('FIELD.USER.TEAM.NAME') }}</th>
                                <th>{{ $t('FIELD.GLOBAL.CREATION') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="resultTeam.length === 0">
                                <td class="tC">
                                    {{ $t('FIELD.GLOBAL.NODATA') }}
                                </td>
                            </tr>
                            <tr v-else v-for="(team, idx) in resultTeam">
                                <td class="tC w10">
                                    <label class="checkbox-wrap">
                                        <input type="checkbox" :value="team.TEAMNO" v-model="selResultTeam" />
                                        <i class="check-icon"></i>
                                    </label>
                                </td>
                                <td class="tC">{{ team.TEAMNO }}</td>
                                <td class="tC">{{ team.TEAMNAME }}</td>
                                <td class="tC">{{ team.CREATIONYN }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                -->
                <div class="tab_cont" style="display: none;">
                    <table class="scroll_table">
                        <colgroup>
                            <col width="15%" />
                            <col width="30%" class="pc_only" />
                            <col width="30%" class="pc_only" />
                            <col width="*" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th class="w10">
                                    <label class="checkbox-wrap">
                                        <input type="checkbox" @click="chkAllAuthList" />
                                        <i class="check-icon"></i>
                                    </label>
                                </th>
                                <th>{{ $t('FIELD.GLOBAL.ID') }}</th>
                                <th>{{ $t('FIELD.USER.NAME') }}</th>
                                <th>{{ $t('FIELD.GLOBAL.CREATION') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="resultUser.length === 0">
                                <td class="tC">
                                    {{ $t('FIELD.GLOBAL.NODATA') }}
                                </td>
                            </tr>
                            <tr v-else v-for="(user, idx) in resultUser">
                                <td class="tC w10">
                                    <label class="checkbox-wrap">
                                        <input type="checkbox" :value="user.LOGINID" v-model="selResultUser" />
                                        <i class="check-icon"></i>
                                    </label>
                                </td>
                                <td class="tC">{{ user.LOGINID }}</td>
                                <td class="tC">{{ user.LOGINNM }}</td>
                                <td class="tC">{{ user.CREATIONYN }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- //Authorization tab -->

        <div class="btn_wrap_full topLine"></div>
        <!-- //Register Info-->

        <div class="btn_wrap_full">
            <a href="javascript:" class="btn_white size_full" @click="btnList">{{ $t('BUTTON.GLOBAL.LIST') }}</a>
            <div class="btn_right" v-if="sysAdmYn == 'Y'">
                <a v-if="STATUS === 'R'" href="javascript:" class="btn_blue" @click="btnStart">{{ $t('BUTTON.GLOBAL.SERVICE.START') }}</a>
                <a v-if="superUser === 'Y'" href="javascript:" class="btn_blue" @click="btnSave">{{ $t('BUTTON.GLOBAL.SAVE') }}</a>
                <a v-if="superUser === 'Y'" href="javascript:" class="btn_blue" @click="btnDelete">{{ $t('BUTTON.GLOBAL.DELETE') }}</a>
            </div>
        </div>
    </div>
</div>
<!-- contents -->
</template>
<script>
import Vue                                  from 'vue';
import axios                                from 'axios';
import qs                                   from 'query-string';
import { mapGetters, mapActions }           from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import resize                               from 'vue-resize-directive'
import api                                  from '@/service';
import store                                from '@/vuex/store';
import constants                            from '@/constants';
import SDLLocale                            from '@/mixin/SDLLocale';
import SDLPagination                        from '~~c/control/pagination/Pagination';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

import DatePicker                           from '~c/DatePicker';
import SKPBreadcrumbs                       from '~vb/main/SKPBreadcrumbs';

import RoleAddPopup                         from '~va/system/menu/RoleAddPopup';
import UserAddPopup                         from '~va/system/userRole/UserAddPopup';
import TeamAddPopup                         from './popup/TeamAddPopup';

require('moment-jdateformatparser');

const MAX_DATE = new Date(2999,12,31),
      MIN_DATE = new Date(1900,1,1);

// BOARD_ID 로 Detail 정보 가져오기
const fetchDetail = boardId => axios.post(
    `${SDLUtil.API_URL}/basis/admin/knowledgeManager/boardManage/boardManageDetail.skp`,
    qs.stringify({ BOARD_ID: boardId }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

// Board service start
const fetchStart = params => axios.post(
    `${SDLUtil.API_URL}/basis/admin/knowledgeManager/boardManage/boardManageStart.skp`,
    qs.stringify(params), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

// BoardManage save
const fetchUpdate = params => axios.post(
    `${SDLUtil.API_URL}/basis/admin/knowledgeManager/boardManage/boardManageUpdate.skp`,
    qs.stringify(params), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

// /basis/admin/knowledgeManager/boardManage/boardManageStart.skp

export default {
    name: 'BoardManageDetail',
    props: {
        boardId: { required: true }
    },
    data() {
        return {
            pageTitle: '',

            rhqCdList: [],              // RHQ List
            corpCdList: [],             // Subsidiary List
            boardType1List: [],         // Board Type List 1
            boardType2List: [],         // Board Type List 2
            nextOrder1List: [],         // Next Order List 1
            nextOrder2List: [],         // Next Order List 2
            discardedPreiodList: [],    // Discarded Period List
            tableHeaderList: [],

            // board detail information
            detail: {},
            headerList: [],
            resultAuth: [],
            resultTeam: [],
            resultUser: [],

            chkAllHeader: false,
            selHeaderList: [],
            chkAllAuth: false,
            selResultAuth: [],
            chkAllTeam: false,
            selResultTeam: [],
            chkAllUser: false,
            selResultUser: [],

            tabName: 'role',

            // detail values
            BOARD_ID: '',
            BOARD_NM: '',
            BOARD_NM_EN: '',
            BOARD_DESC: '',
            BOARD_DESC_EN: '',
            BOARD_TYPE1: '',
            BOARD_TYPE2: '',
            BOARD_TYPE3: '',
            LIST_CNT: 0,
            ATTACH_YN: false,
            EVALUTION_YN: false,
            RECOMMEND_USE_YN: false,
            REG_USER_NO: '',
            REG_USER_NM: '',
            REG_DT: '',
            MODF_USER_NM: '',
            MODF_USER_NO: '',
            MODF_DT: '',
            SYSTEM_ID: '',
            MENU_ID: '',
            STATUS: '',
            RHQ_CD: '',
            CORP_NO: '',
            DISCARDED_PERIOD: '',
            VERIFY_USE_YN: false,
            NEXT_ORDER1: '',
            NEXT_ORDER2: '',
            ORDER_LEVEL: '',
            MENU_GROUP_CD: '',
            MENU_GROUP_DETAIL_CD: '',
            sysAdmYn:'',
        }
    },
    computed: {
        ...mapGetters({
            loginNo: 'getLoginNo',
            loginRhq: 'getLoginRhq',
            userRoles: 'getRoles',
            userCorpCd: 'getCorpCd',
            superUser: 'getSuperUserYn',
            params: 'getParams',
            locale: 'getLocale',
            menus: 'getMenus',
        }),
        getLoginNo()            { return this.loginNo || ''; },
        getUserRole()           { return this.userRoles || []; },
        getUserCorpCd()         { return this.userCorpCd || ''; },
        getSelBoardType1()      { return this.BOARD_TYPE1 || ''; },
        getSelBoardType2()      { return this.BOARD_TYPE2 || ''; },
        getIsDetail() {
            if (!SDLUtil.isNull(this.BOARD_ID) && this.BOARD_ID === this.boardId) {
                return true;

            } else {
                return false;
            }
        }
    },
    components: {
        'skp-breadcrumbs'   : SKPBreadcrumbs,
    },
    methods: {
        async initLoad() {
            SDLUtil.showLoadingBar(true);
            // 기간
            this.setDiscardedPeriod();
            // 헤더 컬럼
            this.setHeaderColumnList();

            return await fetchDetail(this.boardId)
                .then( res => {
                    let data = res.data;
                    return data;
                })
                .catch( err => {
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        setTabName(e) {
            this.tabName = e.target.getAttribute('data-id');
        },
        tabClick() {
            //category list
            $(".tab_wrap li").on("click", function () {
                var li_index = $(".tab_menus li").index(this);
                if ($(this).hasClass("on") == true) {
                    $(this).removeClass("on");
                    $(".tab_wrap .tab_cont").hide();
                } else {
                    $(".tab_wrap li").removeClass("on");
                    $(".tab_wrap .tab_cont").hide();
                    $(this).addClass("on");
                    $(".tab_wrap .tab_cont").eq(li_index).show();
                }
                return false;
            });
        },

        setRhqCdAndCorpNo(rhqCd, corpNo = '') {
            let that = this;
            this.getCodeComboList(this.loginNo, "RHQ_AUTH_ACCESS_CD", this.getLoginNo)
                .then(data => {
                    this.rhqCdList = data, this.RHQ_CD = rhqCd;

                    this.getCodeComboList(rhqCd, "SUB_AUTH_ACCESS_CD", this.getLoginNo)
                        .then(data => {
                            this.corpCdList = data, this.CORP_NO = corpNo || '';
                        });
                });
        },
        setDiscardedPeriod() {
            let that = this;
            this.getCommonCodeList('DISCARDED_PERIOD')
                .then(data => {
                    this.discardedPreiodList = data, this.DISCARDED_PERIOD = '';
                });
        },
        setHeaderColumnList() {
            this.getCodeComboList('HEADER_COLUMN', 'KNOWLEDGE_TABLE_HAEDER')
                .then(data => {
                    this.tableHeaderList = data;
                });
        },
        // 지역 코드 변경 이벤트
        changeRhqCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if (comboValue === "") {
                this.corpCdList = [], this.CORP_NO = '';

            } else {
                this.getCodeComboList(comboValue, "SUB_AUTH_ACCESS_CD", this.getLoginNo).then(data => {
                    this.corpCdList = data, this.CORP_NO = '';
                });
            }
        },
        // 법인 코드 변경 이벤트
        changeCorpCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if (comboValue === "") {
                this.boardType1List = [], this.BOARD_TYPE1 = '';
                this.boardType2List = [], this.BOARD_TYPE2 = '';
            } else { // boardType1List
                this.getCodeComboList(comboValue, "BOARD_TYPE1_MENU").then(data => {
                    this.boardType1List = data, this.BOARD_TYPE1 = '';
                    this.boardType2List = [],   this.BOARD_TYPE2 = '';
                });
            }
        },
        // Code combo list api
        async getCommonCodeList(categoryCode) {
            const codeResp = await api.getCommonCodeList(categoryCode);
            return codeResp;
        },
        // Code combo list api
        async getCodeComboList(categoryVal, categoryCode, additionalValue = '') {
            additionalValue = additionalValue ? additionalValue : this.getUserCorpCd;
            const codeResp = await api.getComboList(categoryVal, categoryCode, additionalValue);
            return codeResp;
        },
        getComboBoxVal(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).value : "";
        },
        getComboBoxName(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).name : "";
        },
        // Board1 setting
        setBoardType1And2(boardType1, boardType2 = '', nextOrder1 = '', nextOrder2 = '') {
            this.getCodeComboList(this.getUserCorpCd, "BOARD_TYPE1_MENU").then(data => {
                this.BOARD_TYPE1 = boardType1;
                this.boardType1List = data;

                this.getCodeComboList(boardType1, "NEXT_ORDER1").then(data => {
                    this.nextOrder1List = data, this.NEXT_ORDER1 = nextOrder1;
                });

                this.getCodeComboList(boardType1, "BOARD_TYPE2_MENU").then(data => {
                    this.boardType2List = data, this.BOARD_TYPE2 = boardType2;
                    this.nextOrder2List = [],   this.NEXT_ORDER2 = nextOrder2;
                });
            });
        },
        // Board1 combo change event => create Board2 combo list
        changeBoardType1(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if (comboValue == "") {
                this.boardType2List = [], this.BOARD_TYPE2 = '';

            } else {
                this.getCodeComboList(comboValue, "NEXT_ORDER1").then(data => {
                    this.nextOrder1List = data, this.NEXT_ORDER1 = '';
                });

                this.getCodeComboList(comboValue, "BOARD_TYPE2_MENU", this.CORP_NO).then(data => {
                    this.boardType2List = data, this.BOARD_TYPE2 = '';
                    this.nextOrder2List = [],   this.NEXT_ORDER2 = '';
                });
            }
        },
        // Board2 combo change event => create Next Order2 combo list
        changeBoardType2(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if (comboValue == "") {
                this.nextOrder2List = [], this.NEXT_ORDER2 = '';

            } else {
                this.getCodeComboList(comboValue, "BOARD_TYPE3").then(data => {
                    this.nextOrder2List = data, this.NEXT_ORDER2 = '';
                });
            }
        },
        changeOrder(e) {
            this.BOARD_TYPE2 = '';
            this.NEXT_ORDER2 = '';
        },
        boardDataSetting(data) {
            Vue.$log.info('▶ BoardManageDetail.vue boardDataSetting =>', data);
            if (data.result.rowCount === 0) {
                SDLUtil.alert({
                    msg: 'MESSAGE.DATA.FIND.NODATA',
                    onOkEvt: () => {
                        this.$router.push({ name: 'BoardManageList' });
                    }
                });
            };

            this.detail                                         = data.result.rowData[0] || {};
            this.headerList                                     = data.headerList.rowData || [];
            if (data.resultAuth.rowCount > 0) this.resultAuth    = data.resultAuth.rowData;
            if (data.resultTeam.rowCount > 0) this.resultTeam    = data.resultTeam.rowData;
            if (data.resultUser.rowCount > 0) this.resultUser    = data.resultUser.rowData;

            this.BOARD_ID                   = this.detail.BOARD_ID;
            this.BOARD_NM                   = this.detail.BOARD_NM;
            this.BOARD_NM_EN                = this.detail.BOARD_NM_EN;
            this.BOARD_DESC                 = this.detail.BOARD_DESC;
            this.BOARD_DESC_EN              = this.detail.BOARD_DESC_EN;
            this.BOARD_TYPE1                = this.detail.BOARD_TYPE1;
            this.BOARD_TYPE2                = this.detail.BOARD_TYPE2;
            this.BOARD_TYPE3                = this.detail.BOARD_TYPE3;
            this.LIST_CNT                   = this.detail.LIST_CNT || 10;
            this.ATTACH_YN                  = this.detail.ATTACH_YN === 'Y' ? true : false;
            this.EVALUTION_YN               = this.detail.EVALUTION_YN === 'Y' ? true : false;
            this.RECOMMEND_USE_YN           = this.detail.RECOMMEND_USE_YN === 'Y' ? true : false;
            this.REG_USER_NO                = this.detail.REG_USER_NO;
            this.REG_USER_NM                = this.detail.REG_USER_NM;
            this.REG_DT                     = this.detail.REG_DT;
            this.MODF_USER_NM               = this.detail.MODF_USER_NM;
            this.MODF_USER_NO               = this.detail.MODF_USER_NO;
            this.MODF_DT                    = this.detail.MODF_DT;
            this.SYSTEM_ID                  = this.detail.SYSTEM_ID;
            this.MENU_ID                    = this.detail.MENU_ID;
            this.STATUS                     = this.detail.STATUS;
            this.RHQ_CD                     = this.detail.RHQ_CD;
            this.CORP_NO                    = this.detail.CORP_NO;
            this.DISCARDED_PERIOD           = this.detail.DISCARDED_PERIOD;
            this.VERIFY_USE_YN              = this.detail.VERIFY_USE_YN === 'Y' ? true : false;
            this.NEXT_ORDER1                = this.detail.ORDER_LEVEL == '2' ? this.detail.NEXT_ORDER : '';
            this.NEXT_ORDER2                = this.detail.ORDER_LEVEL != '2' ? this.detail.NEXT_ORDER : '';
            this.ORDER_LEVEL                = this.detail.ORDER_LEVEL;
            this.MENU_GROUP_CD              = this.detail.MENU_GROUP_CD;
            this.MENU_GROUP_DETAIL_CD       = this.detail.MENU_GROUP_DETAIL_CD;

            // RHQ
            this.setRhqCdAndCorpNo(this.RHQ_CD, this.CORP_NO);
            // 게시판 타입 1 로드
            this.setBoardType1And2(this.BOARD_TYPE1, this.BOARD_TYPE2, this.NEXT_ORDER1, this.NEXT_ORDER2);
        },

        // List Column buttons
        chkAllHeaderList() {
            if (this.chkAllHeader) {
                this.chkAllHeader = false;
                this.selHeaderList = [];

            } else {
                let tempList = [];
                for(let i = 0; i < this.headerList.length; i++) {
                    tempList.push(this.headerList[i].BOARD_HEADER_ID);
                }

                this.chkAllHeader = true;
                this.selHeaderList = tempList;
            }
        },
        // headerList up event
        btnColUp() {
            let that = this;
            if (this.selHeaderList.length !== 1) {
                SDLUtil.alert('MESSAGE.SELECT.ONLY.ONE');

            } else {
                let idx = _.findIndex(this.headerList, function(h){ return h.BOARD_HEADER_ID === that.selHeaderList[0]; });
                if (idx >= 0) {
                    let newHeaderList = this.headerList,
                        moveHeader = this.headerList[idx];
                    let newIdx = idx - 1;
                    if (newIdx <= 0) newIdx = 0;
                    newHeaderList.splice(idx, 1);
                    newHeaderList.splice(newIdx, 0, moveHeader);

                    this.headerList = newHeaderList;
                };
            }
        },
        // headerList down event
        btnColDown() {
            let that = this;
            if (this.selHeaderList.length !== 1) {
                SDLUtil.alert('MESSAGE.SELECT.ONLY.ONE');

            } else {
                let idx = _.findIndex(this.headerList, function(h){ return h.BOARD_HEADER_ID === that.selHeaderList[0]; });
                if (idx <= this.headerList.length) {
                    let newHeaderList = this.headerList,
                        moveHeader = this.headerList[idx];
                    let newIdx = idx + 1;
                    if (newIdx >= this.headerList.length) { newIdx = this.headerList.length; }
                    newHeaderList.splice(idx, 1);
                    newHeaderList.splice(newIdx, 0, moveHeader);

                    this.headerList = newHeaderList;
                };

            }
        },
        // headerList add event
        btnColAdd() {
            this.headerList.push({
                BOARD_HEADER_ID: 'tempCol_' + StringUtil.guid(),
                HEADER_COLUMN: '',
                HEADER_NAME: '',
                HEADER_WIDTH: 0,
                HEADER_ALIGN: '',
                HEADER_ORDER: 0,
            });
        },
        // headerList delete event
        btnColDelete() {
            if (this.selHeaderList.length > 0) {
                for(let i = 0; i < this.selHeaderList.length; i++) {
                    let selHeader = this.selHeaderList[i];
                    let idx = _.findIndex(this.headerList, function(h){ return h.BOARD_HEADER_ID === selHeader; });
                    this.headerList.splice(idx, 1);
                }

                this.selHeaderList = [];

            } else {
                SDLUtil.alert('MESSAGE.DATA.CHECKDELETE');
            }
        },

        // Authorization buttons
        chkAllAuthList() {
            if (this.tabName === 'role') {
                if (this.chkAllAuth) {
                    this.chkAllAuth = false, this.selResultAuth = [];

                } else {
                    let tempList = [];
                    for(let i = 0; i < this.resultAuth.length; i++) {
                        tempList.push(this.resultAuth[i].AUTHID);
                    }

                    this.chkAllAuth = true, this.selResultAuth = tempList;
                }

            } else if (this.tabName === 'team') {
                if (this.chkAllTeam) {
                    this.chkAllTeam = false, this.selResultTeam = [];

                } else {
                    let tempList = [];
                    for(let i = 0; i < this.resultTeam.length; i++) {
                        tempList.push(this.resultTeam[i].TEAMNO);
                    }

                    this.chkAllTeam = true, this.selResultTeam = tempList;
                }

            } else if (this.tabName === 'user') {
                if (this.chkAllUser) {
                    this.chkAllUser = false, this.selResultUser = [];

                } else {
                    let tempList = [];
                    for(let i = 0; i < this.resultUser.length; i++) {
                        tempList.push(this.resultUser[i].LOGINID);
                    }

                    this.chkAllUser = true, this.selResultUser = tempList;
                }

            } else {
                Vue.$log.error('▶ BoardManageDetail.vue table not selected.');
            };
        },
        // 권한 추가 팝업, role/team/user
        btnAuthAdd() {
            if (this.tabName === 'role') {
                SDLUtil.show(
                    RoleAddPopup,
                    {
                        title: 'TITLE.POPUP.SELECT.ROLE',
                        pMenuMode: true,
                        rtnRoleFunc: (obj) => {
                            if (!SDLUtil.existArrays(this.resultAuth, 'AUTHCORPID', obj.AUTHCORPID)) {
                                this.resultAuth.push({ AUTHCORPID: obj.AUTHCORPID, AUTHID: obj.AUTHID, AUTHNM: obj.AUTHNM, CREATIONYN: obj.CREATIONYN });
                            }
                        }
                    },
                    { height: 'auto' },
                );

            } else if (this.tabName === 'team') {
                SDLUtil.show(
                    TeamAddPopup,
                    {
                        title: 'TITLE.POPUP.SELECT.TEAM',
                        pMenuMode: true,
                        rtnFunc: (obj) => {
                            if (!SDLUtil.existArrays(this.resultTeam, 'TEAMNO', obj.TEAMNO)) {
                                this.resultTeam.push({ TEAMNO: obj.TEAMNO, TEAMNAME: obj.TEAMNAME, CREATIONYN: obj.CREATIONYN });
                            }
                        }
                    },
                    { height: 'auto' },
                );

            } else if (this.tabName === 'user') {
                let that = this;
                SDLUtil.show(
                    UserAddPopup,
                    {
                        title: 'TITLE.POPUP.SEARCH.USER',
                        pRhqCdList: this.rhqCdList,
                        pCorpNoList: this.corpNoList,
                        pMenuMode: true,
                        rtnUserFunc: (authUsers, creationYn) => {
                            authUsers.forEach(elm => {
                                const spl = elm.split('^');
                                const obj = { LOGINNO: spl[0], LOGINID: spl[1], LOGINNM: spl[2], CREATIONYN: creationYn };

                                if (!SDLUtil.existArrays(that.resultUser, 'LOGINID', obj.LOGINID)) {
                                    that.resultUser.push({ LOGINID: obj.LOGINID, LOGINNM: obj.LOGINNM, CREATIONYN: obj.CREATIONYN });
                                }
                            });
                        }
                    },
                    { height: 'auto' },
                );

            } else {
                Vue.$log.error('▶ BoardManageDetail.vue table not selected.');
            }
        },
        // 권한 삭제, role/team/user
        btnAuthDelete() {
            let authList = [], selAuthList = [];
            if (this.tabName === 'role') {
                if (this.selResultAuth.length > 0) {
                    for(let i = 0; i < this.selResultAuth.length; i++) {
                        let selAuth = this.selResultAuth[i];
                        let idx = _.findIndex(this.resultAuth, function(h){ return h.AUTHCORPID === selAuth; });
                        this.resultAuth.splice(idx, 1);
                    }

                    this.selResultAuth = [];

                } else {
                    SDLUtil.alert('MESSAGE.DATA.CHECKDELETE');
                }

            } else if (this.tabName === 'team') {
                if (this.selResultTeam.length > 0) {
                    for(let i = 0; i < this.selResultTeam.length; i++) {
                        let selAuth = this.selResultTeam[i];
                        let idx = _.findIndex(this.resultTeam, function(h){ return h.TEAMNO === selAuth; });
                        this.resultTeam.splice(idx, 1);
                    }

                    this.selResultTeam = [];

                } else {
                    SDLUtil.alert('MESSAGE.DATA.CHECKDELETE');
                }

            } else if (this.tabName === 'user') {
                if (this.selResultUser.length > 0) {
                    for(let i = 0; i < this.selResultUser.length; i++) {
                        let selAuth = this.selResultUser[i];
                        let idx = _.findIndex(this.resultUser, function(h){ return h.LOGINID === selAuth; });
                        this.resultUser.splice(idx, 1);
                    }

                    this.selResultUser = [];

                } else {
                    SDLUtil.alert('MESSAGE.DATA.CHECKDELETE');
                }

            } else {
                Vue.$log.error('▶ BoardManageDetail.vue table not selected.');
            }
        },
        // Validation
        validBoardManager() {
            let that = this;
            return new Promise(function(resolve) {
                // Validation check 'groupId : basic'
                if (SDLUtil.onSubmitValidation('basic')) {
                    let validList = SDLUtil.getValidList(), validId = '';
                    for(let valid of validList) {
                        if (_.find(valid.el.classList, function(c){ return c === 'warning'; }) == 'warning') {
                            validId = valid.el.id;
                        }
                    };

                    return resolve({ result: false, validId: validId });
                };

                // Default parameters
                let params = {
                    result              : true,
                    BOARD_ID            : that.BOARD_ID || '',
                    BOARD_NM            : that.BOARD_NM || '',
                    BOARD_NM_EN         : that.BOARD_NM_EN || '',
                    BOARD_DESC          : that.BOARD_DESC || '',
                    BOARD_DESC_EN       : that.BOARD_DESC_EN || '',
                    BOARD_TYPE1         : that.BOARD_TYPE1 || '',
                    BOARD_TYPE2         : that.BOARD_TYPE2 || '',
                    BOARD_TYPE3         : that.BOARD_TYPE3 || '',
                    LIST_CNT            : that.LIST_CNT || 10,
                    ATTACH_YN           : StringUtil.boolToStr(that.ATTACH_YN),
                    EVALUTION_YN        : StringUtil.boolToStr(that.EVALUTION_YN),
                    RECOMMEND_USE_YN    : StringUtil.boolToStr(that.RECOMMEND_USE_YN),
                    RHQ_CD              : that.RHQ_CD || '',
                    CORP_NO             : that.CORP_NO || '',
                    DISCARDED_PERIOD    : that.DISCARDED_PERIOD,
                    VERIFY_USE_YN       : StringUtil.boolToStr(that.VERIFY_USE_YN),
                    NEXT_ORDER1         : that.NEXT_ORDER1 || '',
                    NEXT_ORDER2         : that.NEXT_ORDER2 || '',
                    ORDER_LEVEL         : that.ORDER_LEVEL,
                    MENU_GROUP_CD       : that.MENU_GROUP_CD || '',
                    MENU_GROUP_DETAIL_CD: that.MENU_GROUP_DETAIL_CD || '',
                    SYSTEM_ID           : that.SYSTEM_ID,
                    MENU_ID             : that.MENU_ID,
                };

                // Board header list 가 있는 경우
                if (that.headerList.length > 0) {
                    let HEADER_COLUMN = [], HEADER_NAME = [], HEADER_WIDTH = [], HEADER_ALIGN = [];
                    for(let h = 0; h < that.headerList.length; h++) {
                        HEADER_COLUMN.push(that.headerList[h].HEADER_COLUMN);
                        HEADER_NAME.push(that.headerList[h].HEADER_NAME);
                        HEADER_WIDTH.push(that.headerList[h].HEADER_WIDTH);
                        HEADER_ALIGN.push(that.headerList[h].HEADER_ALIGN);
                    }

                    Object.assign(params, {
                        HEADER_COLUMN: HEADER_COLUMN,
                        HEADER_NAME: HEADER_NAME,
                        HEADER_WIDTH: HEADER_WIDTH,
                        HEADER_ALIGN: HEADER_ALIGN
                    });
                };

                // Board role list 가 있는 경우
                if (that.resultAuth.length > 0) {
                    let authCorpId = [], authId = [], authNm = [], authCreationYn = [];
                    for(let r = 0; r < that.resultAuth.length; r++) {
                        authCorpId.push(that.resultAuth[r].AUTHCORPID);
                        authId.push(that.resultAuth[r].AUTHID);
                        authNm.push(that.resultAuth[r].AUTHNM);
                        authCreationYn.push(that.resultAuth[r].CREATIONYN);
                    };

                    Object.assign(params, {
                        authCorpId: authCorpId,
                        authId: authId,
                        authNm: authNm,
                        authCreationYn: authCreationYn,
                    });
                };

                // Board user list 가 있는 경우
                if (that.resultUser.length > 0) {
                    let loginNo = [], loginNm = [], userCreationYn = [];
                    for(let r = 0; r < that.resultUser.length; r++) {
                        loginNo.push(that.resultUser[r].LOGINNO);
                        loginNm.push(that.resultUser[r].LOGINNM);
                        userCreationYn.push(that.resultUser[r].CREATIONYN);
                    };

                    Object.assign(params, {
                        loginNo: loginNo,
                        loginNm: loginNm,
                        userCreationYn: userCreationYn,
                    });
                };

                Vue.$log.info('▶ BoardManageRegister.vue save contents =>', params);

                return resolve(params);
            });
        },

        // Board Detail buttons
        // List 이동
        btnList() {
            this.$router.push({ name: 'BoardManageList' });
        },
        // Board service start
        async btnStart() {
            let that = this;
            await this.validBoardManager().then(params => {
                if (params.result) {
                    SDLUtil.confirm({
                        title: 'BUTTON.GLOBAL.SERVICE.START',
                        msg: 'MESSAGE.DATA.SAVE.CONFIRM',
                        onOkEvt: () => {
                            fetchStart(params).then(res => {
                                let data = res.data;
                                SDLUtil.alert({
                                    title: 'TITLE.POPUP.MESSAGE.DETAIL',
                                    msg: data.msg,
                                    onOkEvt: () => {
                                        that.btnList();
                                    }
                                });
                            })
                            .catch(err => {
                                SDLUtil.showLoadingBar(false);
                                SDLUtil.alert(err);
                            });
                        }
                    });

                } else {
                    return document.getElementById(params.validId).focus();
                }
            })
        },
        // Save event
        async btnSave() {
            // /basis/admin/knowledgeManager/boardManage/boardManageUpdate.skp
            await this.validBoardManager().then(params => {
                if (params.result) {
                    fetchUpdate(params).then(res => {
                        let data = res.data;
                        SDLUtil.alert({
                            title: 'TITLE.POPUP.MESSAGE.DETAIL',
                            msg: data.msg,
                            onOkEvt: () => {
                                this.btnList();
                            }
                        });
                    })
                    .catch(err => {
                        SDLUtil.showLoadingBar(false);
                        SDLUtil.alert(err);
                    });

                } else {
                    return document.getElementById(params.validId).focus();
                }
            })
        },
        // Delete event
        btnDelete() {
            SDLUtil.confirm({
                title: "TITLE.WARNING.TITLE",
                msg: 'MESSAGE.DATA.DELETE.CONFIRM',
                onOkEvt: () => {
                    return  axios.post(
                                `${SDLUtil.API_URL}/basis/admin/knowledgeManager/boardManage/boardManageDelete.skp`,
                                qs.stringify({
                                    boardId: this.BOARD_ID,
                                    corpNo: this.CORP_NO,
                                    menuId: this.MENU_ID,
                                    systemId: 'SKP'
                                }),
                                { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                            )
                            .then(res => {
                                let data = res.data;
                                if (data.msg) {
                                    SDLUtil.alert({
                                        title: 'FIELD.GLOBAL.PROGRESS.COMPLETE',
                                        msg: _.replace(data.msg, /(\r?\\n)/g, '<br/>'),
                                        onOkEvt: () => {
                                            // Knowledge Trash
                                            this.btnList();
                                        }
                                    });
                                }
                            })
                            .catch(err => {
                                SDLUtil.errorAlert(err);
                            });
                }
            });
        }
    },
    created() {
        Vue.$log.info('▶ BoardManageDetail.vue created. => BOARD_ID:', this.boardId);
    },
    mounted() {
    	this.sysAdmYn = SDLUtil.isRoleExist(`${constants.SYSTEM_ADMIN}`) ? 'Y' : 'N' ;
        this.$nextTick(() => {
            this.initLoad().then( data => {
                this.boardDataSetting(data);
                this.tabClick();
                SDLUtil.showLoadingBar(false);
            });
        });
    },
    beforeDestroy() {

    }
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/admin/knowledgeManager/boardManage/BoardManageDetail.vue